// extracted by mini-css-extract-plugin
export default {"activePowerTable":"ElectricityBillActivePower_activePowerTable__0jUdW"};